import React from 'react';
import { connect } from "react-redux";
import { useEffect } from "react";
import {
    Box,
    Typography,
    Divider

} from '@mui/material';
import '../PujaConfirmationComponent/PujaConfirmationComponent.css';
import { setpujadetail } from '../../store/actions/puja';

const PujaConfirmationComponent = ({
    pujabookingdetails,
}) => {

    let attendingText;
    switch (pujabookingdetails.pujaPerson) {
        case 'Yes':
            attendingText = "You will be attending in person.";
            break;
        case 'No':
            attendingText = "You will NOT be attending in person.";
            break;
        default:
            attendingText = "";
    }
    return (
        <>
            <Box
                className='puja-confirmation'
                component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1 },
                    mx: 20,
                    pt: 6
                }}
                noValidate
                autoComplete="off"
            >
                <div>
                    <Typography sx={{ pb: 4, fontWeight: '600', color: '#010101' }}>
                        Please check details below and confirm:
                    </Typography>
                    <Box className="label-puja-confirm" sx={{ pb: 3 }}>
                        <label>You have booked:</label>
                        <Box sx={{ pb: 2, pt: 2 }}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                {pujabookingdetails.pujaName} on {pujabookingdetails.pujaDate}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                {attendingText}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider sx={{ mb: 2 }} />
                    <Box className="label-puja-confirm" sx={{ pb: 3 }}>
                        <label>Sankalpam Details:</label>
                        <Box sx={{ pt: 1 }}>
                            <Typography sx={{ color: '#8E8E8E', whiteSpace: "pre-line", wordBreak: "break-word" }}>
                                {pujabookingdetails.pujaDetail}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider sx={{ mb: 2 }} />
                    <Box className="label-puja-confirm" sx={{ pb: 2 }}>
                        <label>Devotee Contact Details:</label>
                        <Box sx={{ pb: 1, pt: 1 }}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                <strong>Name:</strong> {pujabookingdetails.pujaUserName || "-"}
                            </Typography>
                        </Box>
                        <Box sx={{ pb: 1 }}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                <strong>Contact Number:</strong> {pujabookingdetails.pujaUserContact || "-"}
                            </Typography>
                        </Box>
                        <Box sx={{ pb: 1 }}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                <strong>Alternate Number:</strong> {pujabookingdetails.pujaUserAlt || "-"}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider sx={{ mb: 2 }} />
                    <Box className="label-puja-confirm" sx={{ pb: 2 }}>
                        <label>Additional Details:</label>
                        <Box sx={{ pb: 1 }}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                <strong>Email:</strong> {pujabookingdetails.userEmail || "-"}
                            </Typography>
                        </Box>
                        <Box sx={{ pb: 1 }}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                <strong>PAN No:</strong> {pujabookingdetails.userPanNo || "-"}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography sx={{ color: '#8E8E8E', whiteSpace: "pre-line", wordBreak: "break-word" }}>
                                <strong>Comments:</strong> {pujabookingdetails.userComments || "-"}
                            </Typography>
                        </Box>
                    </Box>
                    <Divider sx={{ mb: 2 }} />
                    <Box>
                        <Typography sx={{ pb: 3, fontWeight: '600', color: '#010101' }}>
                            Mailing Address (to send Prasadam):
                        </Typography>
                        <Box sx={{ pb: 1 }}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                <strong>Name:</strong> {pujabookingdetails.pujamailName || "-"}
                            </Typography>
                        </Box>
                        <Box sx={{ pb: 1 }}>
                            <Typography sx={{ color: '#8E8E8E', whiteSpace: "pre-line" }}>
                                <strong>Address:</strong> {pujabookingdetails.pujamailAddress || "-"}
                            </Typography>
                        </Box>
                        <Box sx={{ pb: 1 }}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                <strong>Pincode:</strong> {pujabookingdetails.pujamailPincode || "-"}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography sx={{ color: '#8E8E8E' }}>
                                <strong>Mobile:</strong> {pujabookingdetails.pujamailMobile || "-"}
                            </Typography>
                        </Box>
                    </Box>
                </div>
            </Box>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        pujabookingdetails: state.puja.pujabookingdetails,
    };

}

export default connect(mapStateToProps, {

})(PujaConfirmationComponent);